export class ExecutorPositiveBalanceReport {
  positive_balance_sum: number = 0;
}
